export const PAGE_TITLES: Record<string, string> = {
  "/": "Home",

  "/auth/login": "Sign In",
  "/auth/sso": "SSO Sign In",
  "/auth/mfa": "Two-Factor Authentication",
  "/auth/mfa-totp": "Two-Factor Authentication",
  "/auth/expired": "Session Expired",
  "/auth/unauthorized": "Unauthorized",
  "/auth/forgot-password": "Forgot Password",
  "/auth/reset-password": "Reset Password",
  "/auth/reset-password/:token": "Reset Password",
  "/invite": "Accept Invitation",
  "/invite/:token": "Accept Invitation",
  "/issuer-invite": "Accept Issuer Invitation",
  "/issuer-invite/:token": "Accept Issuer Invitation",
  "/select-tenant": "Select Organisation",
  "/onboarding/welcome": "Onboarding",
  "/onboarding/portal": "Onboarding Portal",
  "/onboarding/portal/:token": "Onboarding Portal",
  "/terms": "Terms of Service",
  "/privacy": "Privacy Policy",
  "/privacy/request": "Privacy Request",
  "/privacy/verify/:token": "Privacy Verification",
  "/status": "Platform Status",
  "/v": "Verify Credential",
  "/v/:token": "Verify Credential",
  "/verify/ptw": "Verify Permit",
  "/verify/ptw/:token": "Verify Permit",
  "/s": "Share Space",
  "/s/:token": "Share Space",
  "/s/:token/contact": "Share Space",
  "/s/:token/privacy": "Share Space Privacy",
  "/s/:token/privacy/request": "Privacy Request",
  "/p": "Proposal",
  "/p/:token": "Proposal",
  "/t/:partnerSlug": "Trust Center",
  "/discover": "Discover",
  "/t": "Trust Center",
  "/link-expired": "Link Expired",

  "/tenant/dashboard": "Dashboard",
  "/tenant/setup-checklist": "Setup Checklist",
  "/dashboard": "Dashboard",

  "/companies": "Companies",
  "/companies/:id": "Company",
  "/companies/:id/dashboard": "Company Dashboard",
  "/project-companies": "Project Companies",
  "/company-analytics": "Company Analytics",
  "/departments/:id": "Department",
  "/divisions/:id": "Division",
  "/projects": "Projects",
  "/projects/:id": "Project",

  "/sites": "Sites",
  "/sites/:id": "Site",
  "/sites/:id/topology": "Topology Builder",
  "/areas": "Areas",
  "/areas/:id": "Area",
  "/gates": "Gates",
  "/gates/:id": "Gate",
  "/devices": "Devices",
  "/visitors": "Visitors",

  "/attendance-ledger": "Attendance Ledger",
  "/attendance-ledger/:id": "Attendance Record",
  "/time-attendance/shifts": "Shift Definitions",
  "/time-attendance/rosters": "Roster Management",
  "/time-attendance/rosters/:id/calendar": "Roster Calendar",
  "/time-attendance/assignments/:id": "Shift Assignment",
  "/time-attendance/attendance-policy": "Attendance Policy",
  "/time-attendance/timesheet-policy": "Timesheet Policy",
  "/time-attendance/leave": "Leave Management",
  "/time-attendance/shift-handovers": "Shift Handovers",
  "/attendance-dashboard": "Attendance Dashboard",
  "/timesheet-dashboard": "Timesheet Dashboard",

  "/documents": "Document Registry",
  "/documents/:id": "Document",
  "/documents/forms": "Document Forms",
  "/documents/acknowledgements": "Acknowledgements",
  "/documents/control": "Document Control",
  "/documents/admin": "Document Admin",
  "/documents/evidence-packs": "Evidence Packs",

  "/actions/my-work": "My Work",
  "/actions/notifications": "Notifications",
  "/actions/alerts": "My Work",
  "/actions/tasks/:id": "Task",

  "/settings": "Settings",
  "/settings/users": "User Management",
  "/settings/roles": "Role Management",
  "/settings/navigation": "Navigation Config",
  "/settings/integrations": "Integrations",
  "/settings/billing": "Billing",
  "/settings/security-identity": "Security & Identity",
  "/settings/notification-templates": "Notification Templates",
  "/settings/alert-configuration": "Alert Configuration",
  "/settings/escalation-ladder": "Escalation Ladder",
  "/settings/task-types": "Task Types",
  "/settings/queue-management": "Queue Management",
  "/settings/orchestration-rules": "Orchestration Rules",
  "/settings/sla-policies": "SLA Policies",
  "/settings/notification-preferences": "Notification Preferences",
  "/settings/auth-audit-log": "Auth Audit Log",
  "/settings/access-settings": "Access Settings",
  "/settings/api-tokens": "API Tokens",
  "/settings/ptw-regulator-audit-pack": "PTW Regulator Audit Pack",
  "/settings/job-health": "Job Health",
  "/settings/features": "Features",
  "/settings/business-rules": "Business Rules",
  "/settings/plan": "Plan & Usage",
  "/settings/company-types": "Company Types",
  "/settings/branding": "Branding",
  "/settings/locale": "Locale Settings",
  "/settings/installed-catalogs": "Installed Catalogs",
  "/settings/permission-simulator": "Permission Simulator",
  "/configure": "Configure",
  "/configure/theme": "Theme",
  "/support": "Support",

  "/ptw": "Permit to Work",
  "/ptw/new": "New Permit",
  "/ptw/audit": "PTW Audit",
  "/ptw/onboarding": "PTW Onboarding",
  "/ptw/reviews": "PTW Reviews",
  "/ptw/reports/chain": "Chain Health Report",
  "/ptw/dashboards": "PTW Dashboards",
  "/ptw/my-queue": "My Permit Queue",
  "/ptw/capacity": "PTW Capacity",
  "/ptw/returned": "Returned Permits",
  "/ptw/settings": "PTW Settings",
  "/ptw/shift-handover": "Shift Handover",
  "/ptw/simops": "SimOps",
  "/ptw/library": "PTW Templates",
  "/ptw/webhooks": "PTW Webhooks",
  "/ptw/competency-matrix": "PTW Competency Matrix",
  "/ptw/templates": "PTW Templates",
  "/ptw/workflows": "PTW Workflows",
  "/ptw/pdf-defaults": "PTW PDF Defaults",
  "/ptw/:permitId": "Permit",

  "/workforce": "Workforce Hub",
  "/workforce/roster": "Worker Roster",
  "/workforce/roster/:id": "Worker Profile",
  "/workforce/roster/onboarding": "Onboarding",
  "/workforce/roster/onboarding/new": "New Worker Intake",
  "/workforce/roster/onboarding/:id": "Onboarding Record",
  "/workforce/operations": "Operations Hub",
  "/workforce/inductions": "Inductions",
  "/workforce/training": "Training Programs",
  "/workforce/competencies": "Competencies",
  "/workforce/readiness": "Unified Readiness",
  "/workforce/readiness-rules": "Readiness Rules",
  "/mobilization": "Mobilization",
  "/mobilization/dashboard": "Mobilization Dashboard",
  "/mobilization/batch": "Batch Mobilization",
  "/mobilization/:id": "Mobilization Record",
  "/workers/add/success": "Worker Added",

  "/credentials": "Credentials",
  "/credentials/issue": "Issue Credential",
  "/credentials/verify": "Verify Credential",
  "/credentials/:id": "Credential",
  "/issuer-portal": "Issuer Portal",
  "/bundles": "Credential Bundles",
  "/credential-audit-trail": "Credential Audit Trail",
  "/revocation": "Revocation Hub",
  "/credential-templates": "Credential Templates",
  "/template-marketplace": "Template Marketplace",
  "/evidence": "Evidence",
  "/expiry": "Expiring Credentials",

  "/safety-admin": "Safety Admin",
  "/toolbox-talks": "Toolbox Talks",
  "/safety/toolbox-talks": "Toolbox Talks",
  "/safety/report": "Report Safety Event",
  "/safety/triage": "Safety Triage",
  "/safety/cases": "Safety Cases",
  "/safety/cases/:id": "Safety Case",
  "/safety/non-conformances": "Non-Conformances",
  "/safety/non-conformances/:id": "Non-Conformance",
  "/safety/dashboard": "Safety Dashboard",
  "/access-requests": "Access Requests",
  "/access/access-policies": "Access Policies",
  "/access/gate-operations": "Gate Operations",
  "/access/event-log": "Access Event Log",
  "/access/supervisor-area": "Supervisor Area",
  "/access/project-dashboard": "Project Access Dashboard",
  "/access/compliance": "Access Compliance",
  "/access/worker-readiness": "Worker Access Readiness",
  "/operations/muster": "Muster & Emergency",
  "/approval-matrix": "Approval Matrix",

  "/equipment/dashboard": "Equipment Dashboard",
  "/equipment/registry": "Equipment Registry",
  "/equipment/classifications": "Equipment Classifications",
  "/equipment/inspection-templates": "Inspection Templates",
  "/equipment/maintenance-plans": "Maintenance Plans",
  "/equipment/certifications": "Equipment Certifications",
  "/equipment/audit-log": "Equipment Audit Log",
  "/equipment/maintenance": "Maintenance Work Orders",
  "/equipment/inspections": "Inspection Execution",
  "/equipment/tool-issue-return": "Tool Issue & Return",
  "/equipment/compliance": "Equipment Compliance",

  "/sharing/spaces": "Share Spaces",
  "/sharing/dsar": "DSAR Inbox",
  "/sharing/leads": "Leads Inbox",
  "/sharing/forms": "Form Designer",
  "/sharing/proposals": "Proposal Builder",
  "/sharing/integrations": "Share Integrations",
  "/sharing/api-tokens": "API Token Manager",
  "/sharing/bulk-import": "Bulk Import",
  "/sharing/discover": "Discover",
  "/sharing/worker-oversight": "Worker Oversight",
  "/sharing/trust-center": "Trust Center",
  "/sharing/domains": "Share Domains",

  "/partner/home": "Partner Home",
  "/partner/dashboard": "Partner Dashboard",
  "/partner/workers": "Partner Workers",
  "/partner/upload": "Bulk Upload",
  "/partner/certs": "Partner Certifications",
  "/partner/jobs": "Active Jobs",
  "/partner/readiness": "Worker Readiness",
  "/partner/verifications": "Identity Verifications",
  "/partner/permits": "Partner Permits",
  "/partner/attendance": "Partner Attendance",
  "/partner/timesheets": "Partner Timesheets",
  "/partner/safety": "Partner Safety",
  "/partner/documents": "Partner Documents",
  "/partner/account": "Partner Account",
  "/partner/analytics": "Partner Analytics",
  "/partner/marketplace": "Marketplace Listing",
  "/partner/agreements": "Partner Agreements",
  "/partner/team": "Partner Team",
  "/partner/branding": "Partner Branding",
  "/partner/compliance": "Partner Compliance",
  "/partner/evidence": "Partner Evidence",
  "/partner/inbox": "Partner Inbox",
  "/partner/audit-log": "Partner Audit Log",
  "/marketplace/partners": "Partner Directory",
  "/marketplace/partners/:companyId": "Partner Profile",

  "/worker/wallet": "My Wallet",
  "/worker/wallet/:id": "Credential",
  "/worker/wallet/:id/present": "Present Credential",
  "/worker/wallet/:id/appeal": "Appeal Credential",
  "/worker/wallet/present": "Present Credential",
  "/worker/wallet/requests": "Credential Requests",
  "/worker/wallet/notifications": "Wallet Notifications",
  "/worker/wallet/notifications/preferences": "Notification Preferences",
  "/worker/portfolio": "My Portfolio",
  "/worker/portfolio/:id": "Portfolio Builder",
  "/worker/portfolio/:id/preview": "Portfolio Preview",
  "/worker/portfolio/:id/analytics": "Portfolio Analytics",
  "/worker/identity/id-capture": "ID Capture",
  "/worker/welcome": "Welcome",
  "/worker/readiness": "My Readiness",
  "/worker/tasks": "My Tasks",
  "/worker/ptw": "My Permits",
  "/worker/permits": "My Permits",
  "/worker/privacy": "My Privacy",
  "/worker/today": "Today",
  "/worker/history": "History",
  "/worker/more": "More",
  "/worker/timesheets": "My Timesheets",
  "/worker/audit-log": "Audit Log",
  "/worker/access-log": "Access Log",
  "/worker/access-log/:workerId": "Worker Access Log",
  "/worker/muster-response": "Muster Response",
  "/worker/muster": "Muster Response",
  "/worker/shifts": "My Shifts",

  "/workers/inductions": "Inductions",
  "/workers/add": "Add Worker",
  "/workers/:id": "Worker Profile",
  "/workers": "Worker Roster",

  "/contractor/dashboard": "Partner Dashboard",
  "/contractor/workers": "Partner Workers",
  "/contractor/upload": "Bulk Upload",
  "/contractor/certs": "Partner Certifications",
  "/contractor/jobs": "Active Jobs",
  "/contractor/attendance": "Partner Attendance",
  "/contractor/timesheets": "Partner Timesheets",

  "/operations/headcount": "Headcount",
  "/operations/situational-map": "Situational Map",
  "/operations/dashboard": "Operations Hub",
  "/operations/deployments": "Deployments",
  "/operations/lifecycle": "Lifecycle",
  "/operations/transfers": "Transfers",
  "/operations/suspensions": "Suspensions",
  "/operations/demobilizations": "Demobilizations",
  "/operations/offboarding": "Offboarding",

  "/onboarding": "Onboarding",
  "/onboarding/:id": "Onboarding Record",
  "/onboarding/intake": "Worker Intake",
  "/onboarding/analytics": "Onboarding Analytics",
  "/onboarding/invitations": "Onboarding Invitations",
  "/onboarding/bulk-import": "Bulk Import",

  "/equipment": "Equipment Dashboard",
  "/equipment/tools": "Equipment Registry",
  "/equipment/defects": "Equipment Dashboard",

  "/actions/analytics": "Work Analytics",
  "/actions/sla-performance": "SLA Performance",
  "/actions/inbox": "My Work",
  "/actions/tasks": "My Work",
  "/actions/queues": "My Work",
  "/actions/supervisor": "My Work",
  "/actions/company-admin": "My Work",
  "/actions/leadership": "My Work",

  "/analytics/queue-health": "Queue Health",
  "/analytics/sla-performance": "SLA Performance",
  "/analytics/escalation": "Escalation Analytics",
  "/analytics/action-completion": "Action Completion",
  "/analytics/leadership": "Leadership Analytics",

  "/revocation-dashboard": "Revocation Hub",
  "/revocation-wizard": "Revocation Wizard",
  "/revocation-center": "Revocation Center",
  "/revocation-governance": "Revocation Governance",
  "/verify": "Verify Credential",
  "/verifier": "Verify Credential",
  "/settings/revocation-governance": "Revocation Governance",

  "/workforce/readiness-bundles": "Readiness Bundles",
  "/workforce/assignments": "Readiness Assignments",
  "/workforce/waivers": "Readiness Waivers",
  "/workforce/audit-log": "Workforce Audit Log",

  "/ptw-workflows": "PTW Workflows",
  "/settings/ptw-workflows": "PTW Workflows",
  "/settings/ptw-pdf-defaults": "PTW PDF Defaults",
  "/supervisor/shift-handover": "Shift Handover",
  "/equipment/ptw-panel": "PTW Equipment Panel",

  "/admin/sso": "Security & Identity",
  "/admin/performance": "Platform Diagnostics",
  "/credentials/bulk-revoke": "Revocation Center",
  "/credentials/batch-validate": "Verify Credential",
  "/credentials/kiosk": "Verify Credential",

  "/super-admin/kill-switch": "Feature Kill Switch",
  "/super-admin/participation-role-types": "Entity Taxonomy",
  "/super-admin/operations-monitor": "Platform Diagnostics",
  "/super-admin/performance": "Platform Diagnostics",
  "/super-admin/organizations/:id": "Company",
  "/super-admin/company-types": "Entity Taxonomy",
  "/super-admin/partner-compliance": "Partner Governance",
  "/super-admin/partner-access-requests": "Partner Governance",
  "/super-admin/subscription-tiers": "Commercial Workspace",
  "/super-admin/partner-plans": "Commercial Workspace",
  "/super-admin/partner-subscriptions": "Commercial Workspace",
  "/super-admin/partner-revenue": "Commercial Workspace",
  "/super-admin/workers": "Workforce Oversight",
  "/super-admin/workers/:id": "Worker Detail",
  "/super-admin/worker-identity": "Workforce Oversight",
  "/super-admin/marketplace": "Workforce Oversight",
  "/super-admin/relationship-oversight": "Workforce Oversight",
  "/super-admin/workforce-compliance": "Workforce Oversight",
  "/super-admin/partner-commercial": "Commercial Workspace",

  "/access/policies": "Access Policies",
  "/access/policy-simulate": "Access Policies",
  "/access/security-dashboard": "Access Compliance",
  "/access/compliance-dashboard": "Access Compliance",
  "/policy-overview": "Access Policies",

  "/safety/report-incident": "Report Safety Event",
  "/safety/report-observation": "Report Safety Event",
  "/safety/investigations": "Safety Cases",
  "/safety/actions": "Safety Cases",
  "/safety/containment": "Safety Cases",
  "/settings/safety-admin": "Safety Admin",

  "/partner/unassigned": "Partner Home",

  "/documents/form-reviews": "Document Forms",
  "/documents/evidence-gallery": "Evidence Packs",
  "/documents/controlled-lifecycle": "Document Control",
  "/documents/compliance-dashboard": "Document Control",
  "/documents/taxonomy": "Document Admin",
  "/documents/form-templates": "Document Admin",
  "/documents/workflows": "Document Admin",
  "/documents/evidence-pack-rules": "Document Admin",
  "/documents/retention": "Document Admin",
  "/documents/acknowledgement-mgmt": "Acknowledgements",

  "/supervisor/today": "Supervisor Today",
  "/supervisor/history": "Supervisor History",
  "/supervisor/workforce-readiness": "Workforce Readiness",
  "/supervisor/crew-attendance": "Crew Attendance",
  "/supervisor/exceptions": "Exception Queue",
  "/supervisor/timesheet-approval": "Timesheet Approval",
  "/supervisor/audit-log": "Supervisor Audit Log",

  "/super-admin": "Super Admin",
  "/super-admin/dashboard": "Super Admin Dashboard",
  "/super-admin/customers": "Customers Hub",
  "/super-admin/catalogs": "Catalogs Hub",
  "/super-admin/govern": "Govern Hub",
  "/super-admin/operate": "Operate Hub",
  "/super-admin/metrics": "Platform Metrics",
  "/super-admin/metrics/history": "Metrics History",
  "/super-admin/setup": "Platform Setup",
  "/super-admin/tenants": "Tenants",
  "/super-admin/tenants/create": "Create Tenant",
  "/super-admin/tenants/:id": "Tenant",
  "/super-admin/tenants/:id/timeline": "Tenant Timeline",
  "/super-admin/tenant-onboarding/:id": "Tenant Onboarding",
  "/super-admin/regions": "Regions",
  "/super-admin/regions/create": "Create Region",
  "/super-admin/regions/success": "Region Created",
  "/super-admin/regions/:id": "Region",
  "/super-admin/partners": "Partners",
  "/super-admin/partners/:id": "Partner",
  "/super-admin/partner-governance": "Partner Governance",
  "/super-admin/bulk-partner-onboard": "Bulk Partner Onboard",
  "/super-admin/bulk-invitations": "Bulk Invitations",
  "/super-admin/operate/workforce": "Workforce Oversight",
  "/super-admin/operate/workforce/workers/:id": "Worker Detail",
  "/super-admin/partner-agreements": "Partner Agreements",
  "/super-admin/partner-onboarding/:id": "Partner Onboarding",
  "/super-admin/companies": "Companies",
  "/super-admin/companies/:id": "Company",
  "/super-admin/entity-taxonomy": "Entity Taxonomy",
  "/super-admin/users": "Users",
  "/super-admin/users/:id": "User",
  "/super-admin/commercial": "Commercial Workspace",
  "/super-admin/governance": "Governance Workspace",
  "/super-admin/feature-governance": "Feature Governance",
  "/super-admin/platform-catalog": "Platform Catalog",
  "/super-admin/permission-catalog": "Permission Catalog",
  "/super-admin/feature-catalog": "Feature Catalog",
  "/super-admin/feature-kill-switch": "Feature Kill Switch",
  "/super-admin/plans": "Plans & Modules",
  "/super-admin/addon-modules": "Addon Modules",
  "/super-admin/severity-matrix": "Severity Matrix",
  "/super-admin/deploy": "Deploy Console",
  "/super-admin/entitlement-governance": "Entitlement Governance",
  "/super-admin/partner-access-profiles": "Partner Access Profiles",
  "/super-admin/policies": "Platform Policies",
  "/super-admin/audit": "Audit Log",
  "/super-admin/audit-events": "Audit Events",
  "/super-admin/usage": "Usage Dashboard",
  "/super-admin/config-library": "Configuration Library",
  "/super-admin/config-library/glossary": "Config Library Glossary",
  "/super-admin/configuration": "Configuration Catalog",
  "/super-admin/blueprints": "Platform Blueprints",
  "/super-admin/blueprints/new": "New Platform Blueprint",
  "/super-admin/blueprints/:id/edit": "Edit Platform Blueprint",
  "/super-admin/ptw/blueprints": "PTW Blueprints",
  "/super-admin/config-packs": "Config Packs",
  "/super-admin/configuration-presets": "Configuration Presets",
  "/super-admin/platform-defaults": "Platform Defaults",
  "/super-admin/workflow-config": "Workflow Config",
  "/super-admin/workflow-config/ptw": "PTW Workflow Config",
  "/super-admin/workflow-config/orchestration": "Orchestration Config",
  "/super-admin/workflow-config/onboarding": "Onboarding Config",
  "/super-admin/workflow-config/timesheet": "Timesheet Config",
  "/super-admin/workflow-config/inspection": "Inspection Config",
  "/super-admin/onboarding-config": "Onboarding Config",
  "/super-admin/business-rules-defaults": "Business Rules Defaults",
  "/super-admin/settings": "SA Settings",
  "/super-admin/bulk-operations": "Bulk Operations",
  "/super-admin/diagnostics": "Platform Diagnostics",
  "/super-admin/support": "Support Tickets",
  "/super-admin/sharing/privacy": "Privacy Templates",
  "/super-admin/sharing/trust-center": "Trust Center Admin",
  "/super-admin/sharing/ai-policy": "Share AI Policy",
  "/super-admin/public-surfaces": "Public Surface Security",
  "/super-admin/dr-drills": "DR Drills",
  "/super-admin/sharing/qa-moderation": "Q&A Moderation",
  "/super-admin/sharing/api-tokens": "Share API Tokens",
  "/super-admin/share-domains": "Share Domains",
  "/super-admin/secrets/health": "Secrets Health",
  "/super-admin/integrations/workos": "WorkOS Integration",
  "/super-admin/integrations": "Integrations Hub",
  "/super-admin/air-gap": "Air Gap Mode",
  "/super-admin/qr": "QR Console",
  "/super-admin/marketplace-moderation": "Marketplace Moderation",
  "/super-admin/watermark-forensics": "Watermark Forensics",
  "/super-admin/status-incidents": "Status Incidents",
  "/super-admin/runtime-tunables": "Runtime Tunables",

  "/admin/audit-events": "Audit Events",
  "/admin/ptw-alerts": "PTW Alert Settings",
  "/admin/runtime-tunables": "Runtime Tunables",
  "/admin/roles": "Role Catalog",
  "/admin/integrations": "Integrations Hub",
};

export function resolvePageTitle(pathname: string): string {
  const clean = pathname.split("?")[0].replace(/\/$/, "") || "/";

  if (PAGE_TITLES[clean]) return PAGE_TITLES[clean];

  const parts = clean.split("/");
  let bestMatch = "";
  let bestScore = 0;

  for (const key of Object.keys(PAGE_TITLES)) {
    const keyParts = key.split("/");
    if (keyParts.length !== parts.length) continue;

    let score = 0;
    let match = true;
    for (let i = 0; i < keyParts.length; i++) {
      if (keyParts[i] === parts[i]) {
        score += 2;
      } else if (keyParts[i].startsWith(":")) {
        score += 1;
      } else {
        match = false;
        break;
      }
    }

    if (match && score > bestScore) {
      bestScore = score;
      bestMatch = key;
    }
  }

  if (bestMatch) return PAGE_TITLES[bestMatch];

  let prefixMatch = "";
  let prefixLen = 0;
  for (const key of Object.keys(PAGE_TITLES)) {
    if (
      !key.includes(":") &&
      (clean === key || clean.startsWith(key + "/")) &&
      key.length > prefixLen
    ) {
      prefixLen = key.length;
      prefixMatch = key;
    }
  }

  return prefixMatch ? PAGE_TITLES[prefixMatch] : "";
}
